import { Injectable } from '@angular/core';

export class TreeNode {
  key: string = '';
  children: TreeNode[] = [];
  level: number = 0;
  expand: boolean = false;
  parent?: TreeNode;
  disabled: boolean = false;
  include: string[] = [];
  exclude: string[] = [];
  [key: string]: any;
}

export class TreeMap {
  [key: string]: TreeNode[];
}

@Injectable()
export class TreeDataService {
  collapse(array: TreeNode[], data: TreeNode, $event: boolean): void {
    if ($event === false) {
      if (data.children) {
        data.children.forEach(d => {
          const target = array.find(a => a.key === d.key);
          if (target) target.expand = false;
        });
      } else {
        return;
      }
    }
  }

  build(rootNodes: TreeNode[], expand: boolean = false, visitNode?: (value: TreeNode) => void): TreeMap {
    const tree = new TreeMap();
    rootNodes.forEach((node, index) => {
      if (!node.key) {
        node.key = `root_${index}`;
      }
      tree[node.key] = this.buildTreeStructure(node, expand, visitNode);
    });
    return tree;
  }

  private buildTreeStructure(root: TreeNode, expand: boolean, visitNode?: (value: TreeNode) => void): TreeNode[] {
    const stack: TreeNode[] = [];
    const array: TreeNode[] = [];
    const hashMap = {};
    root.level = 0;
    root.expand = expand;
    stack.push(root);

    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (visitNode) visitNode(node);
      if (node.children && node.children.length > 0) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          const child = node.children[i];
          child.level = node.level + 1;
          child.expand = expand;
          child.parent = node;
          stack.push(child);
        }
      } else {
        node.children = [];
      }
    }

    return array;
  }

  private visitNode(node: TreeNode, hashMap: { [key: string]: boolean }, array: TreeNode[]): void {
    if (!node.key) {
      node.key = `node_${array.length}`;
    }
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }
}
